import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {Image} from './styles/InstitutionsCarouselStyle'
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    paritialVisibilityGutter: 60
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
    paritialVisibilityGutter: 50
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 3,
    paritialVisibilityGutter: 30
  }
};

// Because this is an inframe, so the SSR mode doesn't not do well here.
// It will work on real devices.
const InstitutionsCarousel = (props) => {
  const backendUrl = process.env.REACT_APP_BACKOFFICE_URL?.replace('/api', '') || 'http://localhost:8000';
  
  return (
    <Carousel
      ssr
      autoPlay
      infinite
      // partialVisbile
      //     deviceType={deviceType}
      itemClass="image-item"
      responsive={responsive}
      draggable={false}
      
    >
      {(props.data || []).map((image, idx) => {
          // Si la imagen empieza con /assets, agregar la URL del backend
          const imageUrl = image?.startsWith('/assets') ? `${backendUrl}${image}` : image;
          return (
            <Image
              key={idx}
              draggable={false}
              src={imageUrl}
            />
          );
        })}
    </Carousel>
  );
};

export default InstitutionsCarousel;
